<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item
        label="发送者"
        prop="senderUserId"
      >
        <GridSelect
          style="width: 180px"
          title="选择发送者"
          labelName='userName'
          labelValue='id'
          :value="queryForm.senderUserId"
          :limit="1"
          size="small"
          placeholder="请选择发送者"
          @getValue='(value) => {queryForm.senderUserId = value}'
          :columns="USER_code"
          :searchs="USER_search"
          dataListUrl="/mpp/user/findList"
          entityBeanName="mppUser"
          queryEntityUrl="/mpp/user/get"
        >
        </GridSelect>
      </el-form-item>
      <el-form-item
        label="接收者"
        prop="receiverUserId"
      >
        <GridSelect
          style="width: 180px"
          title="选择接收者"
          labelName='userName'
          labelValue='id'
          :value="queryForm.receiverUserId"
          :limit="1"
          size="small"
          placeholder="请选择接收者"
          @getValue='(value) => {queryForm.receiverUserId = value}'
          :columns="USER_code"
          :searchs="USER_search"
          dataListUrl="/mpp/user/findList"
          entityBeanName="mppUser"
          queryEntityUrl="/mpp/user/get"
        >
        </GridSelect>
      </el-form-item>
      <el-form-item label="消息内容">
        <el-input
          v-model="queryForm.messageContent"
          placeholder="请填写消息内容"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="消息类型">
        <el-select
          placeholder="请选择消息类型"
          clearable
          v-model="queryForm.messageType"
          style="width: 180px"
        >
          <el-option
            v-for="type in messageTypeList"
            :key="type.key"
            :label="type.value"
            :value="type.key"
          > </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="离线消息">-->
<!--        <el-select-->
<!--          placeholder="请选择离线消息"-->
<!--          clearable-->
<!--          style="width: 180px"-->
<!--          size="small"-->
<!--          v-model="queryForm.isOffline"-->
<!--        >-->
<!--          <el-option-->
<!--            label="离线"-->
<!--            :value="1"-->
<!--          >-->
<!--          </el-option>-->
<!--          <el-option-->
<!--            label="在线"-->
<!--            :value="0"-->
<!--          >-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item label="创建时间">
        <el-date-picker
          style="width: 180px"
          v-model="timeRange"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="margin-left: 80px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getSystemList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetDialog"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addSystemMessage()"
          >发布</el-button>
        </div>
        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshSystemList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 用户好友列表-->
      <el-table
        :data="systemList"
        width="100%"
        row-key="id"
        size="small"
        height="50%"
        @selection-change="handleSelectionChange"
        :default-expand-all="true"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="5%"
        > </el-table-column>
        <el-table-column
          align="left"
          label="发送者"
          prop="sender.userName"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="receiver.userName"
          label="接收者"
          min-width="10%"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="messageType"
          label="消息类型"
          min-width="10%"
        >
          <template slot-scope="scop">
            {{scop.row.messageType !== null ? getMessageDesc(scop.row.messageType) : '--'}}
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          align="center"-->
<!--          prop="isOffline"-->
<!--          label="离线消息"-->
<!--          min-width="10%"-->
<!--        >-->
<!--          <template slot-scope="scop">-->
<!--            {{scop.row.isOffline == 0 ? '在线' : '离线'}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          align="center"-->
<!--          prop="isPrivate"-->
<!--          label="私聊消息"-->
<!--          min-width="10%"-->
<!--        >-->
<!--          <template slot-scope="scop">-->
<!--            {{scop.row.isPrivate == 0 ? '否' : '是'}}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="messageContent"
          label="消息内容"
          min-width="15%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="title"
          label="消息标题"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="webUrl"
          label="网页地址"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="imageUrl"
          label="图片地址"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="创建时间"
          min-width="12%"
        >
          <template slot-scope="scpe">
            {{$moment(scpe.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="8%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkSystemMessage(scop.row.messageId)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>

      <!-- 详情信息 -->
      <el-dialog
        :title="shopMoneyRecordStates[shopMoneyRecordState]"
        :visible.sync="showDialog"
        width="50%"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="systemMessage"
            ref="systemMessageForm"
            :rules="rules"
            label-width="120px"
            :inline="true"
            size="mini"
          >
            <el-form-item
              label="发送者"
              prop="senderUserId"
              v-if="systemMessage.senderUserId !== null"
            >
              <GridSelect
                style="width: 180px"
                title="选择发送者"
                labelName='userName'
                labelValue='id'
                :value="systemMessage.senderUserId"
                :limit="1"
                size="small"
                placeholder="请选择发送者"
                :disabled="shopMoneyRecordState == 'check'"
                @getValue='(value) => {systemMessage.senderUserId = value}'
                :columns="USER_code"
                :searchs="USER_search"
                dataListUrl="/mpp/user/findList"
                entityBeanName="mppUser"
                queryEntityUrl="/mpp/user/get"
              >
              </GridSelect>
            </el-form-item>
            <el-form-item
              label="接收者"
              prop="receiverUserId"
              v-if="systemMessage.receiverUserId !== null"
            >
              <GridSelect
                style="width: 180px"
                title="选择接受者"
                labelName='userName'
                labelValue='id'
                :value="systemMessage.receiverUserId"
                :limit="1"
                size="small"
                placeholder="请选择接受者"
                :disabled="shopMoneyRecordState == 'check'"
                @getValue='(value) => {systemMessage.receiverUserId = value}'
                :columns="USER_code"
                :searchs="USER_search"
                dataListUrl="/mpp/user/findList"
                entityBeanName="mppUser"
                queryEntityUrl="/mpp/user/get"
              >
              </GridSelect>
            </el-form-item>
            <el-form-item
              label="标题"
              prop="title"
            >
              <el-input
                style="width : 175px"
                size="small"
                v-model="systemMessage.title"
                :disabled="shopMoneyRecordState == 'check'"
              ></el-input>
            </el-form-item>
<!--            <el-form-item-->
<!--              label="离线消息"-->
<!--              prop="isOffline"-->
<!--            >-->
<!--              <el-select-->
<!--                clearable-->
<!--                placeholder="请选择离线消息"-->
<!--                style="width : 175px"-->
<!--                size="small"-->
<!--                v-model="systemMessage.isOffline"-->
<!--                :disabled="shopMoneyRecordState == 'check'"-->
<!--              >-->
<!--                <el-option-->
<!--                  label="在线"-->
<!--                  :value="0"-->
<!--                >-->
<!--                </el-option>-->
<!--                <el-option-->
<!--                  label="离线"-->
<!--                  :value="1"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item-->
<!--              label="私聊信息"-->
<!--              prop="isPrivate"-->
<!--            >-->
<!--              <el-select-->
<!--                clearable-->
<!--                placeholder="请选择私聊消息"-->
<!--                style="width : 175px"-->
<!--                size="small"-->
<!--                v-model="systemMessage.isPrivate"-->
<!--                :disabled="shopMoneyRecordState == 'check'"-->
<!--              >-->
<!--                  <el-option-->
<!--                      label="公开"-->
<!--                      :value="false"-->
<!--                  >-->
<!--                  </el-option>-->
<!--                <el-option-->
<!--                  label="私聊"-->
<!--                  :value="true"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item
              label="消息类型"
              prop="messageType"
            >
              <el-select
                clearable
                placeholder="请选择消息类型"
                style="width : 175px"
                size="small"
                v-model="systemMessage.messageType"
                :disabled="shopMoneyRecordState == 'check'"
              >
                <el-option
                  v-for="messageType in messageTypeList"
                  :key="messageType.key"
                  :label="messageType.value"
                  :value="messageType.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="创建时间"
              prop="createTime"
              v-if="shopMoneyRecordState == 'check'"
            >
              <el-input
                style="width : 175px"
                size="small"
                v-model="$moment(systemMessage.createTime).format('YYYY-MM-DD HH:mm:ss')"
                :disabled="shopMoneyRecordState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="图片地址"
              prop="imageUrl"
            >
<!--              <el-input-->
<!--                style="width : 175px"-->
<!--                size="small"-->
<!--                v-model="systemMessage.imageUrl"-->
<!--                :disabled="shopMoneyRecordState == 'check'"-->
<!--              ></el-input>-->
                <el-input style="width: 175px" size="small" v-model="systemMessage.imageUrl"
                          :disabled="shopMoneyRecordState == 'check'" placeholder="请上传图片">
                    <el-button slot="append" :disabled="shopMoneyRecordState == 'check'" @click="uploadVideo">上传</el-button>
                </el-input>
                <el-upload v-show="false" ref="uploads" class="uploadAlbum"
                           :before-upload="beforeAvatarUpload"
                           :http-request="uploadAvatar"
                           :show-file-list="false">
                    <el-button type="primary" size="small" class="as" :disabled="shopMoneyRecordState == 'check'">上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item
              label="网页地址"
              prop="webUrl"
            >
              <el-input
                style="width : 175px"
                size="small"
                v-model="systemMessage.webUrl"
                :disabled="shopMoneyRecordState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="消息内容"
              prop="messageContent"
            >
              <el-input
                style="width : 480px"
                type="textarea"
                :rows="6"
                size="small"
                v-model="systemMessage.messageContent"
                :disabled="shopMoneyRecordState == 'check'"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="shopMoneyRecordState == 'add'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from "@/utils/constant"
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetSystemList();
                this.getSystemList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetSystemList();
                this.getSystemList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            timeRange: [],
            queryForm: {
                senderUserId: '', //发送者id
                receiverUserId: '', //接受者id
                startTime: '', //开始时间
                endTime: '', //结束时间
                messageContent: '', //消息内容
                isOffline: '', //是否在线
                messageType: '' //消息类型
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopMoneyRecordState: 'add',
            shopMoneyRecordStates: {
                add: '发布系统消息',
                check: '查看系统消息',
                edit: '修改朋友'
            },

            multipleSelection: [],
            systemList: [],
            messageTypeList: [],
            btnLoading: false,
            systemMessage: {
                //系统消息
                acceptUser: {},
                receiverUserId: '',
                sendUser: {},
                senderUserId: '',
                createTime: '',
                imageUrl: '',
                webUrl: '',
                isOffline: 0,
                isPrivate: false,
                messageContent: '',
                messageType: 1,
                title: ''
            },
            rules: {
                title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
                isOffline: [{ required: true, message: '离线消息不能为空', trigger: 'blur' }],
                isPrivate: [{ required: true, message: '私聊消息不能为空', trigger: 'blur' }],
                messageType: [{ required: true, message: '消息类型不能为空', trigger: 'blur' }],
                senderUserId: [{ required: true, message: '发送者不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getSystemList();
        this.getMessageType();
    },
    methods: {
        //获取消息类型标签
        getMessageDesc(messageType) {
            for (const index in this.messageTypeList) {
                if (this.messageTypeList[index].key == messageType) {
                    return this.messageTypeList[index].value;
                }
            }
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.systemMessage.imageUrl = res.url;
                }
            });
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        uploadVideo() {
            this.$refs.uploads.$el.querySelector(".as").click()
            console.log(this.$refs.uploads)
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetSystemList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.systemList = [];
        },
        resetDialog() {
            this.shopMoneyRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                senderUserId: '', //发送者id
                receiverUserId: '', //接受者id
                startTime: '', //开始时间
                endTime: '', //结束时间
                messageContent: '', //消息内容
                isOffline: '', //是否在线
                messageType: '' //消息类型
            };
            this.timeRange = [];
            this.getSystemList();
        },
        closeDialog() {
            this.resetDialog();
            this.resetProperty();
        },
        //查看
        checkSystemMessage(currenctId) {
            this.shopMoneyRecordState = 'check';
            this.showDialog = true;
            this.getSystemMessage(currenctId);
        },
        //发布
        addSystemMessage() {
            this.shopMoneyRecordState = 'add';
            this.showDialog = true;
        },
        //获取系统详情
        getSystemMessage(id) {
            get(`/im/sys/get`, { messageId: id }).then((res) => {
                if (res.success && res.code == 200) {
                    this.systemMessage = { ...this.systemMessage, ...res.systemMessage };
                }
            });
            console.log(this.systemMessage);
        },
        //重置属性
        resetProperty() {
            this.systemMessage = {
                //系统消息
                acceptUser: {},
                receiverUserId: '',
                sendUser: {},
                senderUserId: '',
                createTime: '',
                imageUrl: '',
                webUrl: '',
                isOffline: 0,
                isPrivate: false,
                messageContent: '',
                messageType: 1,
                title: ''
            };
            this.$refs.systemMessageForm.resetFields();
        },
        //重置按钮
        refreshSystemList() {
            this.resetSystemList();
            this.getSystemList();
        },
        getSystemList() {
            if (this.timeRange != null) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            }
            get(`/im/sys/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.systemList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        //提交数据
        submitForm() {
            if (this.shopMoneyRecordState == 'add') {
                this.$refs.systemMessageForm.validate((valid) => {
                  console.log(this.systemMessage.isPrivate);
                    if (valid) {
                        post(`/im/sys/add`, { ...this.systemMessage }).then((res) => {
                            if (res.success && res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDialog();
                                this.getSystemList();
                                this.resetProperty();
                            }
                        });
                    }
                });
            }
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getSystemList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getSystemList();
        },
        //获取消息类型
        getMessageType() {
            get(`/im/utils/getEnum`, { enumType: `sys_message_type` }).then((res) => {
                if (res.success) {
                    this.messageTypeList = res.enumList;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.moneyRecord-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.moneyRecord-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.moneyRecord-table-expand .el-form-item {
    margin-left: 4%;
    margin-bottom: -1%;
    width: 100%;
}
</style>